<template>
  <div>
    <div class="pages" v-if="!showRule">
      <div class="left-card">
        <h3>行业领域</h3>
        <div class="industries">
          <div
            v-for="(v, i) in worksFields"
            :key="i"
            :class="WorkFieldId == v.id ? 'selected' : ''"
            class="industrie-item"
            @click="goFieldDetailsHandle(v)"
          >
            {{ v.workFieldName }}
          </div>
        </div>
      </div>
      <div class="right-card">
        <div class="table">
          <div class="top-tab">
            <h3>子领域管理</h3>
            <div class="filter">
              <div>
                <el-button
                  type="primary"
                  size="medium"
                  @click="addHandle"
                  v-show="WorkFieldId"
                  >新增</el-button
                >
                <el-button
                  v-show="WorkFieldId"
                  type="primary"
                  size="medium"
                  @click="exportHandle"
                  >导入</el-button
                >
              </div>
              <div class="search">
                <el-form size="small" :inline="true">
                  <el-form-item label="">
                    <el-input
                      clearable
                      v-model="formInline.Key"
                      placeholder="请输入关键词查询"
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="searchList"
                      >搜索</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
          <div v-show="activeName == 0">
            <el-table
              :data="tableData"
              @selection-change="handleSelectionChange"
              height="6.6rem"
              max-height="6.6rem"
              style="width: 100%"
            >
              <el-table-column
                show-overflow-tooltip
                type="index"
                label="序号"
                align="center"
                width="50"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                property="lableName"
                label="子领域名称"
                align="center"
              >
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                property="subCount"
                label="行业方向数量"
                align="center"
              >
              </el-table-column>

              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button @click="see(scope.row)" type="text" size="medium"
                    >查看</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pages justify-end">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="currentSize"
              layout="  prev, pager, next,  sizes, jumper"
              :total="totalCount"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- <setDialog
      :showDialog="setDialogVisible"
      @closeSetDialog="closeSetDialog"
    /> -->
    </div>

    <el-dialog
      title="添加子领域"
      :destroy-on-close="true"
      width="30%"
      :visible.sync="dialogFormVisible"
      @close="closeAddDialog"
    >
      <el-form label-width="90px">
        <el-form-item label="所属领域">
          <el-input
            disabled
            placeholder="请输入所属领域"
            v-model="WorkFieldTitle"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="子领域名称">
          <el-input
            placeholder="请输入子领域名称"
            v-model="WorkSubfieldTitle"
            maxlength="8"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSubWorkField">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 添加行业方向 -->
    <el-dialog
      title="添加行业方向"
      :destroy-on-close="true"
      width="30%"
      :visible.sync="dialogJobFormVisible"
      @close="closeAddDialog2"
    >
      <el-form label-width="90px">
        <el-form-item label="所属领域">
          <el-input
            disabled
            v-model="WorkFieldTitle"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="所属子领域">
          <el-input
            disabled
            v-model="WorkSubfieldTitle"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="行业方向名称">
          <el-input
            placeholder="请输入行业方向名称"
            v-model="WorkJobTitle"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogJobFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSubWorkJob">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 导入弹窗 -->
    <el-dialog
      title="导入"
      :visible.sync="importDialog"
      width="30%"
      @close="closeImportDialog"
    >
      <el-form
        ref="uploadForm"
        :model="uploadForm"
        label-width="80px"
        :rules="importRules"
      >
        <el-form-item label="附件" prop="academyCode">
          <el-upload
            :headers="headers"
            class="upload-demo"
            :action="url"
            :auto-upload="false"
            :on-success="onSuccess"
            ref="upload"
            :before-upload="beforeUpload"
            :on-change="changeFile"
            accept=".xlsx,.xls"
          >
            <el-button size="mini" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xlsx或xls文件</div>
          </el-upload>
        </el-form-item>
        <!-- {{ downloadHred }} -->
        <el-form-item label="模版下载">
          <a
            :href="downloadHred"
            style="color: #4a89dc;"
            download="行业领域导入模板"
            >下载excel模板</a
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDialog = false" style="margin-left: 50px;"
          >取 消</el-button
        >
        <el-button type="primary" @click="onImportCollege">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="行业方向管理"
      :visible.sync="industryDirectionDialog"
      :before-close="handleIndustryClose"
    >
      <div class="filter">
        <div>
          <el-button
            type="primary"
            size="medium"
            @click="addHandle2"
            v-show="WorkFieldId"
            >新增</el-button
          >
        </div>
        <div class="search">
          <el-form size="small" :inline="true">
            <el-form-item label="">
              <el-input
                clearable
                v-model="jobsVal.keyword"
                placeholder="请输入关键词查询"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchList2">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <el-table :data="jobList" max-height="500">
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column
          property="lableName"
          align="center"
          label="职业方向"
        ></el-table-column>
      </el-table>
    </el-dialog>
    <!-- <ruleManage v-if="showRule" @backHander="backHander"/> -->
  </div>
</template>
<script>
import education from "../../components/userDetail/education.vue"; //教育经历认证
// import setDialog from "./components/setDialog.vue";
// import ruleManage from "./components/ruleManage.vue";
import {
  GetWorkFieldsApi,
  GetSubWorkFieldsApi,
  AddtWorkFieldJobApi,
  AddSubWorkFieldApi,
  GetWorkFieldJobsApi,
  WorkFieldTemplateApi,
  GetReturnSchoolPrebooksWaitAuditApi,
  GetReturnSchoolPrebooksRecordApi,
  AuditReturnSchoolPrebookApi,
  GetReturnSchoolPrebookInfoApi
} from "@/request/requestApi.js";
export default {
  data() {
    return {
      url: "",
      uploadForm: {},
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      downloadHred: "",
      apiUrl: "",
      jobsVal: { keyword: "" },
      jobList: [],
      industryDirectionDialog: false,
      WorkFieldId: "",
      WorkFieldTitle: "",
      WorkSubfieldTitle: "",
      WorkSubfieldId: "",
      WorkJobTitle: "",
      dialogFormVisible: false,
      dialogJobFormVisible: false,
      importDialog: false,
      worksFields: [],
      showRule: false,
      //学校
      schoolList: [],
      handleType: 0,
      setDialogVisible: false,
      activeName: 0,
      centerDialogVisible: false,
      tableData: [],
      judgeTableData: [],
      formInline: {
        Key: "",
        IsCar: null,
        IsTogether: null,
        EndYear: "",
        School: "",
        PrebookState: null
      },
      formInline2: {
        Key: ""
      },
      //学生信息
      // currStudentInfo: [],
      currStudentInfo: {
        returnSchoolPrebookVerify: [],
        returnSchoolPrebookTogetherPerson: []
      },
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
      //多选框
      multipleSelection: [],
      //批量审核id
      judIds: []
    };
  },
  created() {
    this.url = window.api.fieldFileUrl;
    this.getSchoolList();
    this.getWorkFields();
    this.apiUrl = window.api.apiurl;
    this.getWorkFieldTemplate();
  },
  mounted() {},
  methods: {
    closeImportDialog() {
      this.$refs.upload.clearFiles();
      this.uploadForm.filePath = "";
    },
    async onImportCollege() {
      try {
        // 检查是否已选择文件
        const uploadFiles = this.$refs.upload.uploadFiles;
        if (!uploadFiles || uploadFiles.length === 0) {
          this.$message.error("请先选择要上传的文件");
          return;
        }

        this.$confirm(
          "为确保数据安全与一致性，添加数据后将无法修改和删除。请确认当前数据准确无误后再执行该操作。是否确认添加数据?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(async () => {
            // 显示加载状态
            const loadingInstance = this.$loading({
              lock: true,
              text: "文件上传中...",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });

            // 手动触发上传
            await new Promise((resolve, reject) => {
              this.$refs.upload.submit();
              // 假设 onSuccess 会处理上传结果
              this.$once("upload-complete", () => {
                loadingInstance.close();
                resolve();
              });
              this.$once("upload-error", error => {
                loadingInstance.close();
                reject(error);
              });
            });

            // 上传成功后关闭对话框
            this.importDialog = false;
            this.goFieldDetails();
          })
          .catch(() => {});
      } catch (error) {
        // this.$message.error("文件上传失败: " + (error.message || "未知错误"));
      }
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isXlsx = fileType === "xlsx";
      const isXls = fileType === "xls";
      if (!isXlsx && !isXls) {
        this.$message.error("只能上传xlsx或xls格式的文件！");
        return false;
      }
      return true;
    },
    changeFile(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    onSuccess(val) {
      if (val.succeed) {
        this.uploadForm.filePath = val.data;
        this.$message.success("文件上传成功！");
        this.$emit("upload-complete"); // 触发上传完成事件
      } else {
        this.$message.error(val.error || "文件上传失败");
        this.$refs.upload.clearFiles();
        this.uploadForm.filePath = "";
        this.$emit("upload-error", val.error); // 触发上传错误事件
      }
    },
    handleIndustryClose() {
      this.industryDirectionDialog = false;
      this.goFieldDetails();
    },
    async exportHandle() {
      this.importDialog = true;
    },
    searchList2() {
      this.currentPage = 1;
      this.getWorkFieldJobs(this.WorkSubfieldId);
    },
    async getWorkFieldTemplate() {
      let res = await WorkFieldTemplateApi();
      if (res.succeed) {
        this.downloadHred = this.apiUrl + res.data;
      }
    },
    async addSubWorkJob() {
      if (!this.WorkJobTitle) {
        return this.$message.error("请输入行业方向名称");
      }
      let res = await AddtWorkFieldJobApi({
        subWorkFieldId: this.WorkSubfieldId,
        name: this.WorkJobTitle
      });
      if (res.succeed) {
        this.dialogJobFormVisible = false;
        this.$message.success("操作成功！");
        this.getWorkFieldJobs(this.WorkSubfieldId);
      }
    },
    async addSubWorkField() {
      if (!this.WorkSubfieldTitle) {
        return this.$message.error("请输入子领域名称");
      }
      let res = await AddSubWorkFieldApi({
        workFieldId: this.WorkFieldId,
        name: this.WorkSubfieldTitle
      });
      if (res.succeed) {
        this.dialogFormVisible = false;
        this.$message.success("操作成功！");
        this.goFieldDetails();
      }
    },
    closeAddDialog() {
      this.WorkSubfieldTitle = "";
    },
    closeAddDialog2() {
      // this.WorkSubfieldTitle = "";
      this.WorkJobTitle = "";
    },
    async getWorkFields() {
      let res = await GetWorkFieldsApi();
      if (res.succeed) {
        this.worksFields = res.data;
        this.WorkFieldId = this.worksFields[0].id;
        this.goFieldDetailsHandle(this.worksFields[0]);
      }
    },
    goFieldDetailsHandle(item) {
      this.WorkFieldId = item.id;
      this.WorkFieldTitle = item.workFieldName;
      this.goFieldDetails();
    },
    //获取学校
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    reject() {
      this.$prompt("确认驳回申请?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.+$/,
        inputErrorMessage: "请填写理由"
      })
        .then(({ value }) => {
          this.adjustStudent([this.currStudentInfo.id], 2, value);
        })
        .catch(() => {});
    },
    submit() {
      this.$confirm("确认通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.adjustStudent([this.currStudentInfo.id], 1);
        })
        .catch(() => {});
    },
    addHandle() {
      this.dialogFormVisible = true;
      this.WorkSubfieldTitle = "";
    },
    addHandle2() {
      this.dialogJobFormVisible = true;
    },
    closeSetDialog() {
      this.setDialogVisible = false;
    },
    //批量审核
    judStudents() {
      if (this.judIds.length <= 0) {
        this.$message.error("请至少选择一条审核信息！");
        return false;
      }
      this.$confirm("确认批量通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.adjustStudent(this.judIds, 1);
        })
        .catch(() => {});
    },
    ruleManageHandle() {
      this.showRule = true;
    },
    backHander() {
      this.showRule = false;
    },
    //关闭
    close() {
      this.centerDialogVisible = false;
    },
    handleSelectionChange(val) {
      this.judIds = [];
      this.multipleSelection = val;
      console.log(this.multipleSelection);
      this.multipleSelection.forEach(element => {
        this.judIds.push(element.id);
      });
      console.log(this.judIds);
    },
    handleClick(tab, event) {
      console.log(tab, event);
      this.formInline = {
        label: "",
        role: "",
        dataValue: "",
        Key: ""
      };
      if (this.activeName == 0) {
        this.goFieldDetails();
      } else if (this.activeName == 1) {
        this.getHistoryStudentList();
      }
    },
    see(val, type) {
      this.industryDirectionDialog = true;
      this.WorkSubfieldTitle = val.lableName;
      this.WorkSubfieldId = val.id;
      this.getWorkFieldJobs(this.WorkSubfieldId);
    },
    async getWorkFieldJobs(SubWorkFieldId) {
      let res = await GetWorkFieldJobsApi({
        SubWorkFieldId: SubWorkFieldId,
        Key: this.jobsVal.keyword,
        PageIndex: 1,
        PageSize: 99999
      });
      if (res.succeed) {
        this.jobList = res.data.data;
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      this.goFieldDetails(this.currentPage, this.currentSize);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.goFieldDetails(this.currentPage, this.currentSize);
    },
    searchList() {
      this.currentPage = 1;
      this.goFieldDetails(this.currentPage);
    },
    //获取列表
    async goFieldDetails(pageIndex = 1, pageSize = 10) {
      let params = {
        WorkFieldId: this.WorkFieldId,
        Key: this.formInline.Key,
        PageIndex: pageIndex,
        PageSize: pageSize
      };
      let res = await GetSubWorkFieldsApi(params);

      if (res.succeed) {
        this.tableData = res.data.data;
        this.totalCount = res.data.total;
        if (this.tableData.length <= 0 && this.currentPage > 1) {
          this.goFieldDetails(--this.currentPage);
        }
      } else {
        this.$message.error(res.error);
      }
    },
    searchHistoryList() {
      this.currentPage = 1;
      this.getHistoryStudentList(this.currentPage);
    },
    //获取历史列表
    async getHistoryStudentList(pageIndex = 1, pageSize = 10) {
      const params = {
        PageIndex: pageIndex,
        PageSize: pageSize,
        IsCar: this.formInline.IsCar,
        EndYear: this.formInline.EndYear,
        School: this.formInline.School,
        Key: this.formInline.Key,
        PrebookState: this.formInline.PrebookState,
        IsTogether: this.formInline.IsTogether
      };
      let res = await GetReturnSchoolPrebooksRecordApi(params);
      if (res.succeed) {
        this.tableData = res.data.item1;
        this.totalCount = res.data.item2;
        this.tableData.forEach(element => {
          element.createTime = element.createTime.substring(0, 10);
        });
        console.log(this.tableData);
      } else {
        this.$message.error(res.error);
      }
    },
    //获取学深信息
    async getStudentInfo(currId) {
      let res = await GetReturnSchoolPrebookInfoApi({ Id: currId });
      if (res.succeed) {
        // this.currStudentInfo = [];
        // this.currStudentInfo.push(res.data);
        this.currStudentInfo = res.data;
      } else {
        this.$message.error(res.error);
      }
    },
    //审核
    async adjustStudent(currId, state, cancleReason = "") {
      let res = await AuditReturnSchoolPrebookApi({
        id: currId,
        auditState: state,
        auditRemark: cancleReason
      });
      if (res.succeed) {
        this.$message.success("操作成功！");
        this.close();
        this.goFieldDetails(this.currentPage, this.currentSize);
      } else {
        this.$message.error(res.error);
      }
    },
    //动态获取url
    getUrl(url, queryConfig) {
      //var queryConfig={"page" : "index", "method" : 2}
      var that = this;
      var _str = "";
      for (var obj in queryConfig) {
        if (!that.isNull(queryConfig[obj])) {
          _str += obj + "=" + queryConfig[obj] + "&";
        }
      }
      console.log(_str.length);
      if (_str.length > 0) {
        return url + _str.substring(0, _str.length - 1);
      } else {
        return "";
      }
    },
    //判空方法
    isNull(val = "") {
      if (val == undefined || val == null) {
        return true;
      }
      var str = val.toString().replace(/(^\s*)|(\s*$)/g, ""); //去除空格;
      if (str == "" || str == undefined || str == null) {
        return true;
      }
    }
  },
  components: {
    // setDialog,ruleManage
  }
};
</script>
<style lang="scss" scoped>
.pages {
  display: flex;
  // justify-content: space-between;
}
.left-card {
  width: 260px;
  // flex: 1;
  padding: 26px 20px;
  background: #ffffff;
  border-radius: 10px;
  h3 {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 20px;
    color: #363636;
  }
  .industries {
    display: flex;
    flex-direction: column;
    height: 700px;
    overflow: auto;
    .industrie-item {
      cursor: pointer;
      padding: 12px 24px;
    }
    .selected {
      background: #5f79f910;
      font-weight: bold;
      font-size: 14px;
      color: #5f79f9;
    }
  }
}
.right-card {
  width: calc(100% - 250px);
  margin-left: 10px;
}
.top-tab {
  // padding: 0.2rem;
  h3 {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 20px;
    color: #363636;
  }
}
.table {
  height: 100%;
  // margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.3rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.filter {
  // padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  display: flex;
  justify-content: space-between;
  >>> .el-form-item {
    margin-bottom: 0;
  }
}
.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;
  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }
  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}
.judge-pop {
  >>> .el-drawer__header span {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }
  >>> .el-descriptions-item__container > span {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
  .state {
    padding: 0.3rem 0.6rem;
    border-bottom: 1px solid #eeeeee;
  }
  .info {
    padding: 0.3rem 0.6rem;
    border-bottom: 1px solid #eeeeee;
    .allow-people {
      margin-top: 0.12rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h3 {
        font-weight: bold;
        font-size: 16px;
        color: #333333;
      }
      .count {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
    }
    .people-list {
      margin-top: 0.2rem;
      padding: 0.24rem;
      background: #507bf410;
      border-radius: 10px;
      .people-item {
        margin-top: 0.24rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .phone,
        .name {
          font-weight: 400;
          font-size: 14px;
          color: #333333;
        }
      }
      .people-item:first-child {
        margin-top: 0 !important;
      }
    }
    .return-reason {
      margin-top: 0.24rem;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      display: flex;
      .reason-text,
      .reason-title {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
      }
      .reason-title {
        white-space: nowrap;
      }
      .reason-text {
        width: 90%;
        word-wrap: break-word;
      }
    }
  }
  .judge-info {
    width: 100%;
    padding: 0.3rem 0.6rem;
    padding-top: 0;
    h3 {
      font-weight: bold;
      font-size: 16px;
      color: #333333;
    }
  }
  .other-info {
    padding: 0.3rem 0.6rem;
    // margin-bottom: 30px;
  }
  .judge-section {
    // position: absolute;
    // bottom: 0;
    width: 100%;
    padding: 0.3rem 0.6rem;
    display: flex;
    justify-content: end;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/industryField/index.vue